import * as React from 'react'
import { useIsMyPeer } from './useIsMyPeer'




type Props = {
  peerId: string,
  children: React.ReactElement
}


const IsPeerOfMeGuard: React.FC<Props> = ({ peerId, children }: Props) => {
  const query = useIsMyPeer(peerId);
  if (query.data === true) {
    return children;
  }

  return <React.Fragment />;
}

export default IsPeerOfMeGuard;

